<template>
  <v-select
    :items="saudacoes"
    label="Saudação"
    item-value="value"
    multiple
    hide-selected
    v-model="saudacoesSelecionadas"
  >
    <template v-slot:item="{ item }">
      <v-icon :color="item.color">{{ item.value === 4 ? 'alarm' : 'email' }}</v-icon>
      <span class="ml-1">{{ item.text }}</span>
    </template>
    <template v-slot:selection="{ item }">
      <v-chip
        close 
        @input="removerSaudacao(item.value)"
      >
        <v-icon :color="item.color">{{ item.value === 4 ? 'alarm' : 'email' }}</v-icon>
      </v-chip>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'FiltroSaudacao',
  data() {
    return {
      saudacoes: [
        {
          value: 4,
          color: 'gray darken-3',
          text: 'Sem acesso há 1 Semana'
        },  
        { 
          value: 3,
          color: 'green',
          text: 'Habilitado'
        }, 
        { 
          value: 2,
          color: 'blue',
          text: 'Sem permissão (Android)'
        },
        { 
          value: 1,
          color: 'orange',
          text: 'Sem permissão no App Lojista'
        }, 
        { 
          value: 0,
          color: 'red',
          text: 'Sem permissão (Android) e App Lojista'
        },
        {
          value: -1,
          color: 'gray darken-3',
          text: 'Desabilitado (Painel Gerencial)'
        }
      ],
      saudacoesSelecionadas: []
    }
  },
  watch: {
    saudacoesSelecionadas() {
      this.filtrarSaudacoes()
    }
  },
  methods: {
    removerSaudacao(value) {
      let resultado = []
      for (let i = 0; i < this.saudacoesSelecionadas.length; i ++) {
        const e = this.saudacoesSelecionadas[i];
        if (e !== value) {
          resultado.push(e)
        }
      }
      this.saudacoesSelecionadas = resultado
    },
    filtrarSaudacoes() {
      this.$emit('filtrar-saudacoes', {
        saudacoes: this.saudacoesSelecionadas
      })
    }
  }
}
</script>
